import React from 'react'
import Header from '../components/Header/Header'
import Navbar from '../components/Navbar/Navbar'

const Immunocon_2025_Travel_Awards = () => {
    return (
        <div>
            <Header />
            <Navbar />
            <div className="px-4">
                <div className="max-w-7xl mx-auto bg-white p-6 ">
                    {/* Header Section */}
                    <header className="flex justify-between items-center mb-2 pb-6">
                        <h1 className="text-3xl md:text-4xl text-blue-800 ">Immunocon-2025 Travel Awards</h1>

                    </header>

                    {/* Content Section */}
                    <section>
                        
                        <p className="text-md md:text-lg text-gray-600 mb-4">
                            The IMMUNOCON-2025 Travel Awards will be granted on a first-come, first-served basis. To be eligible, the applicant must be below 35 years of age and must provide proof of age. Travel has to be made through train (3 tier AC or less). </p>
                        <p className="text-md md:text-lg text-gray-600 mb-4">

                            Additionally, the applicant should be a registered Ph.D. candidate, Project Fellow, Research Assistant, Project Assistant, Project Associate, or Research Associate (RA), and must submit an ID card as evidence of their status. Instructors, Assistant Professors, Faculty members, Scientists, and Project Scientists are not eligible for the award. Applicants must submit a recommendation letter from their mentor or reporting authority confirming that they have no other sources of funding to attend the meeting.
                        </p>
                        <p className="text-md md:text-lg text-gray-600 mb-4">

                            The applicant must be registered for the conference and have submitted an abstract. The travel award provides a maximum of Rs. 4000 (four thousand only), which will be paid on the last day of the conference upon submission of travel proof (ticket etc.). The award money will be handed directly to the applicant. Applications should be submitted to the organizing committee of IMMUNOCON-2025 via email at  immunocon2025@mnnit.ac.in with the subject line "IMMUNOCON-2025 Travel Awards."

                        </p>



                    </section>
                </div>
            </div>
        </div>
    )
}

export default Immunocon_2025_Travel_Awards
